export enum USER_TYPE {
  Patient = 1,
  Provider = 2,
  GP = 3,
  Pharmacist = 4,
  Other,
}
